// Returns short date format without year and day of week
// For example "12 Jan, 11:55"
export function formatDateTimeShort(locale, date) {
  const datePart = date.toLocaleString(locale || 'en-US', {
    month: 'short',
    day: '2-digit'
  });

  const timePart = date.toLocaleString(locale || 'en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return `${datePart}, ${timePart}`;
}

// Returns full date format with year and day of week
// For example "Fri, 12 Jan 2017, 11:55"
export function formatDateTimeFull(locale, date) {
  const datePart = date.toLocaleString(locale || 'en-US', {
    weekday: 'short',
    month: 'long',
    day: '2-digit',
    year: 'numeric',
    hour12: true
  });

  const timePart = date.toLocaleString(locale || 'en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  return `${datePart} ${timePart}`;
}

export function formatMonthDay(locale, date, includeWeekDay) {
  const format = {
    month: 'long',
    day: '2-digit'
  };

  if (includeWeekDay) {
    return date.toLocaleString(locale || 'en-US', { ...format, weekday: 'long' });
  } else {
    return date.toLocaleString(locale || 'en-US', format);
  }
}

export function formatDateTime(locale, date, isFull) {
  if (isNaN(date)) {
    return '';
  }

  return isFull ? formatDateTimeFull(locale, date) : formatDateTimeShort(locale, date);
}



// WEBPACK FOOTER //
// ./src/js/helpers/dateTimeHelpers.js